import {
  formatDateRange,
  formatDayMonth,
  formatWeekdayDayMonth,
  parseDateOnly,
  toDateOnly,
} from '@voll-intelligence/dates';

/*
 * Os rótulos de data do planner sobre o módulo de datas do kit. As datas chegam
 * como ISO cru (`YYYY-MM-DD`) do form e do wire; o que não for uma data real vira
 * vazio, nunca "undefined" nem `Invalid Date`. São os mesmos do `flight_format`
 * do genui-kit, que os cards do chat seguem usando.
 */

/** A data local de hoje em ISO, pelos getters locais (o fuso do runtime). */
export function localDayIso(): string {
  return toDateOnly(new Date());
}

/** As datas de `yearOf` que decidem o ano; uma ilegível conta como a própria. */
function yearSpan(date: Date, yearOf: readonly string[]): Date[] {
  return yearOf.map((iso) => parseDateOnly(iso) ?? date);
}

/** ISO → "25 dez", ou "3 jan 2027" fora do ano corrente. `yearOf` é a régua das
 *  janelas: a ponta inicial passa `[]` (nunca leva ano) e a final passa as duas
 *  pontas, para o ano entrar nela quando QUALQUER uma cai fora do ano corrente. */
export function fmtDayMonth(
  s: string,
  locale: string | null | undefined,
  yearOf: readonly string[] = [s],
): string {
  const date = parseDateOnly(s);
  return date ? formatDayMonth(date, locale, new Date(), yearSpan(date, yearOf)) : '';
}

/** ISO → "Qua, 25 dez", ou "Sex, 3 jan 2027" fora do ano corrente. `yearOf` como
 *  em `fmtDayMonth`. */
export function fmtWeekdayDayMonth(
  s: string,
  locale: string | null | undefined,
  yearOf: readonly string[] = [s],
): string {
  const date = parseDateOnly(s);
  return date ? formatWeekdayDayMonth(date, locale, new Date(), yearSpan(date, yearOf)) : '';
}

/** O vão curto de datas, na gramática da `FlightSummaryPill`: "17 jun", "20–22
 *  jun", "29 jun – 2 jul". Vazio quando a ida não é uma data; volta inválida vira
 *  só ida. */
export function fmtTripRange(out: string, ret: string | undefined, locale: string): string {
  const start = parseDateOnly(out);
  if (!start) return '';
  return formatDateRange(start, ret ? parseDateOnly(ret) : null, locale, new Date());
}
